<script setup>
import AgentLayout from "@/views/layouts/AgentLayout.vue";
import DevicesBoard from "@/components/analytics/DevicesBoard.vue";
</script>

<template>
  <AgentLayout full-width>
    <DevicesBoard />
  </AgentLayout>
</template>
